<invoice-provider-area>

    <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">適格請求書発行事業者<span
            class="status_label status_label-required margin-spacing-2_left"></span></h2>
    <table class="detail_table">
        <tr class="detail_table-row">
            <th class="detail_table-heading">適格請求書発行事業者ですか？</th>
            <td class="detail_table-data">
                <div class="box_flex01">
                    <select name="invoice_provider_state" class="sort-list"
                            id="invoice_provider_state"
                            is="binding-tag"
                            change_func={changeInvoiceProviderState}
                            show_default_error={false}
                    >
                        <option value="{key}" each={key in Object.keys(provider_state_list)}>{provider_state_list[key]}
                        </option>
                    </select>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="detail_table-heading">登録番号</th>
            <td class="detail_table-data">
                <div class="box_flex01">
                    <div class="box_w50 field">

                        <label class="form-heading" for="invoice_provider_number_body">登録番号記載欄（数字13桁）</label>
                        <div class="box_w100 field" style="display:flex">
                            <span style="font-size: 2rem;font-weight: bold;margin-right: 1rem;line-height: 40px">
                                T
                            </span>
                            <input
                                    class={state.class_name_string}
                                    type="text"
                                    name="invoice_provider_number_body"
                                    is="binding-tag"
                                    errmsg="{state.error_message}"
                                    id="invoice_provider_number_body"
                                    readonly={(invoiceProvider.item.invoice_provider_state === "yes") ? false : true}
                                    style="margin-bottom: 0"
                                    using_valid_func={checkProviderNumber}
                                    show_default_error={false}
                                    maxlength="13"
                            >
                        </div>

                        <div class="error" if={state.error_message!==""} style="margin-left:2rem">
                            {state.error_message}
                        </div>

                    </div>
                </div>
            </td>
        </tr>
    </table>

    <p if={invoiceProvider.item.invoice_provider_state === "yes"} style="margin-top:1rem;text-align:center;font-size:1.2rem">
        個人情報(登録基本情報)をまだ登録されていない場合は、<a href="/info/basic-information-application" style="font-weight:bold;font-size:1.5rem">こちら</a>から登録をお願いします
    </p>

    <script>

        import bindingTag from "@tags/parts/info/invoice-provider/binding.riot";
        import invoiceProvider from "@model/invoiceProvider/api";

        const CLASS_NAME_STRING_DEFAULT = "text_input margin-spacing-3_bottom provider_number_input"
        export default {
            components: {
                'binding-tag': bindingTag,
            },
            invoiceProvider: invoiceProvider,
            state: {
                error_message: "",
                class_name_string: CLASS_NAME_STRING_DEFAULT
            },
            provider_state_list: {
                //unknown: "不明",
                no: "いいえ",
                yes: "はい",
            },
            CLASS_NAME_STRING_DEFAULT: "text_input margin-spacing-3_bottom provider_number_input",
            onMounted() {

                this.invoiceProvider.on("change_invoice_provider_number_error_on", (e) => {
                    this.state.number_readonly = false;
                    this.state.error_message = "入力されていません";
                    this.update();
                });
            },
            changeInvoiceProviderState(e) {

                //this.invoiceProvider.item.invoice_provider_number = "";
                invoiceProvider.item.invoice_provider_number_body = "";
                this.state.error_message = "";

                if (e.target.value === "yes") {
                    //登録番号欄のバリデーションイベントの発火。
                    document.getElementById("invoice_provider_number_body").focus()
                    document.getElementById("invoice_provider_state").focus()
                }


                this.update();


            },
            checkProviderNumber(e) {

                this.state.error_message = "";
                this.state.class_name_string = CLASS_NAME_STRING_DEFAULT;

                const readonly = (invoiceProvider.item.invoice_provider_state !== "yes");
                if (!readonly) {
                    if (e.target.value === "") {

                        this.state.error_message = "入力されていません";

                    } else if (e.target.value.match(/[^0-9]/) !== null) {

                        this.state.error_message = "数字以外が入力されています";

                    } else if (e.target.value.length !== 13) {

                        this.state.error_message = "13桁で入力してください(現在" + e.target.value.length + "文字)";

                    } else if (e.target.value.length === 13) {

                        const target_value = e.target.value;
                        const chars_array = target_value.split("")

                        const origin_check_digit = chars_array[0];
                        let sum_even_numbers = 0; //偶数桁の合算
                        let sum_odd_numbers = 0;  //奇数桁の合算
                        //ループ　文字列を全部
                        let index = 1;
                        for (let i = 12; i > 0; i--) {

                            //偶数
                            if (index % 2 === 0) {
                                sum_even_numbers += parseInt(chars_array[i]);
                            } else if (index % 2 === 1) {
                                sum_odd_numbers += parseInt(chars_array[i]);
                            }

                            index++;
                        }

                        const check_digit_base = ((sum_even_numbers * 2) + sum_odd_numbers) % 9;
                        const check_digit = 9 - check_digit_base;

                        if (check_digit !== Number(origin_check_digit)) {
                            this.state.error_message = "登録番号として正しい値ではありません";
                        }

                    }
                }
                this.update();
            }
        }
    </script>


</invoice-provider-area>